import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'root/view/base';

var Wrike_Send = View.extend({
    spaces      : null,
    folders     : {},
    contacts    : null,

    space_id    : '',
    folder_id   : '',
    contact_id  : '',
    importance  : '',

    form_value : {
        title: ''
    },

    events: {
        'click .dropdown-space li'      : 'onSelectSpace',
        'click .dropdown-folder li'     : 'onSelectFolder',
        'click .dropdown-contact li'    : 'onSelectContact',
        'click .dropdown-importance li' : 'onSelectImportance',
        'submit form'                   : 'onSubmit',
        'click .reconnect'              : 'onReconnect'
    },

    dom_handlers: {
        onSelectSpace: function(e) {
            var space_id = $(e.currentTarget).data('key');

            if (space_id != this.space_id) {
                this.space_id  = space_id;
                this.folder_id = this.folders[this.space_id] && this.folders[this.space_id].length ? this.folders[this.space_id][0].id : null;

                this.renderSpaces();
                this.renderFolders();

                if (!this.folders[space_id]) {
                    this.loadFolders(this.space_id);
                }
            }
        },

        onSelectFolder: function(e) {
            var folder_id = $(e.currentTarget).data('key');

            if (folder_id != this.folder_id) {
                this.folder_id = folder_id;
                this.renderFolders();
            }
        },

        onSelectContact: function(e) {
            var contact_id = $(e.currentTarget).data('key');

            if (contact_id != this.contact_id) {
                this.contact_id  = contact_id;

                this.renderContacts();
            }
        },

        onSelectImportance: function(e) {
            var importance = $(e.currentTarget).data('key');

            if (importance != this.importance) {
                this.importance  = importance;

                this.renderImportance();
            }
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            this.$el.find('button[type="submit"]').prop('disabled', true).addClass('loading');

            this.$el.find('.mask-light').show();
            this.$el.find('.progress-loader').width('0%').show();
            var progress = 0;
            var timeout = setInterval(function() {
                progress = Math.min(90, progress + Math.random() * 15);
                this.$el.find('.progress-loader').width(progress + '%');
            }.bind(this), 50);

            Cache.app.request({
                action: 'integration/sendFeedbackToWrike',
                context: this,
                data: _.extend(form_data, {
                    feedback_id : this.model.get('id'),
                    folder_id   : this.folder_id,
                    contact_id  : this.contact_id,
                    importance  : this.importance
                }),
                success: function(response) {
                    this.model.set('wrike_url', response.wrike_url);

                    setTimeout(function() {
                        UI.success('Task created in Wrike');
                        this.trigger('submit:success');
                    }.bind(this), 800);  // wait for animation to finish
                },
                complete: function() {
                    this.$el.find('button[type="submit"]').prop('disabled', false).removeClass('loading');

                    clearInterval(timeout);
                    this.$el.find('.progress-loader').width('100%');
                }
            });
        },

        onReconnect: function(e) {
            var connected_app = Cache.connected_app_oauth.get(Cache.integration_wrike.findWhere({project_id: this.model.get('project_id')})?.get('app_id') || 0);

            if (connected_app) {
                Modals.reconnectConnectedApp(connected_app.get('app_type'), connected_app, () => {
                    Modals.sendToWrike(this.model.id);
                });
            } else {
                window.parent.location = '/account/connected_app';
            }
        }
    },

    initialize: function() {
        this.form_value  = {
            title: ''
        };

        if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
            this.title = 'Feedback for ' + this.model.get('page');
        } else {
            this.title = 'Feedback #' + Util.padLeft(this.model.id, '000000');
        }

        if (this.model.get('title')) {
            this.form_value.title = this.model.get('title');
        }

        this.folders = {};

        this.space_id   = Cache.integration_wrike.findWhere({project_id: this.model.get('project_id')})?.get('wrike_space_id')   || '';
        this.folder_id  = Cache.integration_wrike.findWhere({project_id: this.model.get('project_id')})?.get('wrike_folder_id')  || '';
        this.importance = Cache.integration_wrike.findWhere({project_id: this.model.get('project_id')})?.get('wrike_importance') || '';
    },

    searchSpace: function(space_id) {
        var result = null;

        if (this.spaces) {
            this.spaces.forEach(function(space) {
                if (space.id == space_id) {
                    result = space;
                }
            });
        }

        return result;
    },

    searchContact: function(contact_id) {
        var result = null;

        if (this.contacts) {
            this.contacts.forEach(function(contact) {
                if (contact.id == contact_id) {
                    result = contact;
                }
            });
        }

        return result;
    },

    searchFolder: function(space_id, folder_id) {
        var result = null;

        if (this.folders[space_id]) {
            this.folders[space_id].forEach(function(folder) {
                if (folder.id == folder_id) {
                    result = folder;
                }
            });
        }

        return result;
    },

    searchImportance: function(importance) {
        var result = null;

        var importance_items = [
            {
                name   : 'High',
                colour : '#E80000'
            },
            {
                name   : 'Normal',
                colour : '#EEEEEE'
            },
            {
                name   : 'Low',
                colour : '#6042EC'
            }
        ];

        importance_items.forEach(function(option) {
            if (option.name === importance) {
                result = option;
            }
        });

        return result;
    },

    getChildFolders: function(space_id, folder_id) {
        var folders = this.folders[space_id];
        var child_folders = [];

        if (folders) {
            folders.forEach(function(folder) {
                if (folder.parent_id == folder_id) {
                    child_folders.push(folder);
                }
            });
        }

        if (child_folders.length) {
            return child_folders;
        }

        return null;
    },

    loadSendOptions: function() {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type         : 'wrike',
                project_id: this.model.get('project_id'),
                access_token : this.access_token
            },
            context: this,
            success: function(response) {
                if (response && response.spaces && response.spaces.length) {
                    this.spaces    = response.spaces;
                    this.contacts  = response.contacts;

                    var space = this.searchSpace(this.space_id);
                    if (!space) {
                        this.space_id = this.spaces[0].id;
                    }

                    this.renderSpaces();
                    this.renderContacts();
                    this.renderImportance();

                    this.loadFolders(this.space_id);
                } else {
                    this.renderError();
                }
            }
        });
    },

    loadFolders: function(space_id) {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type     : 'wrike_folders',
                project_id: this.model.get('project_id'),
                space_id : space_id
            },
            context: this,
            success: function(response) {
                if (response && response.folders) {
                    this.folders[space_id] = response.folders;

                    var folder = this.searchFolder(this.space_id, this.folder_id);
                    if (!folder) {
                        this.folder_id = response.folders.length ? response.folders[0].id : null;
                    }

                    this.renderFolders();
                }
            }
        });
    },

    renderSpaces: function() {
        var space_items = '';
        var space = this.searchSpace(this.space_id);

        if (this.spaces) {
            this.spaces.forEach(function(option) {
                space_items += '<li data-key="' + Util.htmlEntities(option.id) + '"' + (option.id == this.space_id ? ' class="selected"' : '') + '>' +
                                    '<img class="icon-img" src="' + option.avatar_url + '">' +
                                    Util.htmlEntities(option.title) +
                                '</li>';
            }.bind(this));
        }

        this.$el.find('.region-spaces').html(
            '<div class="field-label">Space <i class="fas fa-asterisk"></i></div>' +
            '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-space">' +
                '<button type="button" class="dropdown-select">' +
                    (space ? '<img class="icon-img" src="' + space.avatar_url + '">' + Util.htmlEntities(space.title) : '<span class="placeholder-text">No space selected</span>') +
                '</button>' +
                '<div>' +
                    '<div class="dropdown-search">' +
                        '<input type="text" class="solid compact" placeholder="Search by space name">' +
                    '</div>' +
                    '<ul class="dropdown dropdown-select">' + space_items + '</ul>' +
                '</div>' +
            '</div>'
        );
    },

    renderContacts: function() {
        var contact_items = '<li data-key=""'  + (!this.contact_id ? ' class="selected"' : '') + '><img class="icon-img icon-img-round" src="/image/profile.png">Unassigned</li>';
        var contact = this.searchContact(this.contact_id);

        if (this.contacts) {
            this.contacts.forEach(function(option) {
                contact_items += '<li data-key="' + Util.htmlEntities(option.id) + '"' + (option.id == this.contact_id ? ' class="selected"' : '') + '>' +
                                        '<img class="icon-img icon-img-round" src="' + option.avatar_url + '">' +
                                        Util.htmlEntities(option.name) +
                                    '</li>';
            }.bind(this));
        }

        this.$el.find('.region-contacts').html(
            '<div class="field-label">Assign to</div>' +
            '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-contact" data-append="true">' +
                '<button type="button" class="dropdown-select">' +
                    (contact ? '<img class="icon-img icon-img-round" src="' + contact.avatar_url + '">' + Util.htmlEntities(contact.name) : '<span class="placeholder-text">No assignee selected</span>') +
                '</button>' +
                '<div>' +
                    '<div class="dropdown-search">' +
                        '<input type="text" class="solid compact" placeholder="Search by contact name">' +
                    '</div>' +
                    '<ul class="dropdown dropdown-select">' + contact_items + '</ul>' +
                '</div>' +
            '</div>'
        );
    },

    renderImportance: function() {
        var importance = this.searchImportance(this.importance);

        this.$el.find('.region-importance').html(
            '<div class="field-label">Importance</div>' +
            '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-importance" data-append="true">' +
                '<button type="button" class="dropdown-select">' +
                    (this.importance ? '<i class="fas fa-circle fa-xs margin-right-4" style="color:' + importance.colour + ';"></i>' + importance.name : '<span class="placeholder-text">No importance selected</span>') +
                '</button>' +
                '<div>' +
                    '<ul class="dropdown dropdown-select">' +
                        '<li data-key="High"' + (this.importance === 'High' ? ' class="selected"' : '') + '><i class="fas fa-circle fa-xs" style="color:#E80000;"></i>High</li>' +
                        '<li data-key="Normal"' + (this.importance === 'Normal' ? ' class="selected"' : '') + '><i class="fas fa-circle fa-xs" style="color:#EEEEEE;"></i>Normal</li>' +
                        '<li data-key="Low"' + (this.importance === 'Low' ? ' class="selected"' : '') + '><i class="fas fa-circle fa-xs" style="color:#6042EC;"></i>Low</li>' +
                    '</ul>' +
                '</div>' +
            '</div>'
        );
    },

    renderFolders: function() {
        var folder_items = '';
        var folder = this.searchFolder(this.space_id, this.folder_id);

        var _getChild = function(folder_id, level) {
            level++;

            var items = '';
            var child_folders = this.getChildFolders(this.space_id, folder_id);
            if (child_folders) {
                child_folders.forEach(function(child_folder) {
                    items += '<li data-key="' + Util.htmlEntities(child_folder.id) + '"' + (child_folder.id == this.folder_id ? ' class="selected"' : '') + '>';
                    items += '<span style="margin-left:' + ((level - 1) * 20) + 'px;">' + (child_folder.is_project ? '<i class="far fa-fw fa-file-alt info"></i> ' : '<i class="far fa-fw fa-folder info"></i> ') + Util.htmlEntities(child_folder.title) + '</span>';
                    items += '</li>';

                    items += _getChild(child_folder.id, level);
                }.bind(this));
            }

            return items;
        }.bind(this);

        if (this.folders[this.space_id]) {
            this.folders[this.space_id].forEach(function(option) {
                if (!option.parent_id) {
                    folder_items += '<li data-key="' + Util.htmlEntities(option.id) + '"' + (option.id == this.folder_id ? ' class="selected"' : '') + '>' +
                                        Util.htmlEntities(option.title) +
                                    '</li>';

                    folder_items += _getChild(option.id, 0);
                }
            }.bind(this));

            this.$el.find('.region-folders').html(
                '<div class="field-label">Folder / Project <i class="fas fa-asterisk"></i></div>' +
                '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-folder" data-append="true">' +
                    '<button type="button" class="dropdown-select">' +
                        (folder
                        ?
                        (folder.is_project ? '<i class="far fa-fw fa-file-alt info"></i>' : '<i class="far fa-fw fa-folder info"></i>') +
                        ' ' + Util.htmlEntities(folder.title)
                        :
                        '<span class="placeholder-text">No folders selected</span>') +
                    '</button>' +
                    '<div>' +
                        '<div class="dropdown-search">' +
                            '<input type="text" class="solid compact" placeholder="Search by folder or project name">' +
                        '</div>' +
                        '<ul class="dropdown dropdown-select">' + folder_items + '</ul>' +
                    '</div>' +
                '</div>'
            );
        } else {
            this.$el.find('.region-folders').html(
                '<div class="field-label">Folder / Project <i class="fas fa-asterisk"></i></div>' +
                '<div class="loader-placeholder loader-placeholder-medium"></div>'
            );
        }

        this.$el.find('form button:submit').prop('disabled', folder ? false : true);
    },

    renderError: function() {
        var html = '<div class="error-dialog padding-60">' +
                       '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
                       '<h3>Authentication failed</h3>' +
                       '<p class="info">Your Wrike account couldn\'t be connected.</p>' +
                       (Cache.app.isAdmin() ?
                       '<button class="reconnect primary medium">Reconnect Wrike</button>' : '') +
                   '</div>';

        this.$el.html(html);
    },

    render: function() {
        var content = '';

        content += '<div class="progress-loader"></div>';
        content += '<div class="mask-light" style="display:none;"></div>';

        content += '<form class="form-fluid">' +
                        '<div class="modal-integration-innerscroll">' +
                            '<div class="row-50">' +
                                '<div class="region-spaces">' +
                                    '<div class="field-label">Space <i class="fas fa-asterisk"></i></div>' +
                                    '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                                '</div>' +
                                '<div class="region-folders">' +
                                    '<div class="field-label">Folder / Project <i class="fas fa-asterisk"></i></div>' +
                                    '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Title</div>' +
                                '<input type="text" name="title" maxlength="255" class="solid compact" placeholder="' + Util.htmlEntities(this.title) + '">' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Description</div>' +
                                '<textarea name="description" class="solid compact" rows="3"></textarea>' +
                            '</div>' +
                            '<div class="row region-contacts">' +
                                '<div class="field-label">Assign to</div>' +
                                '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                            '</div>' +
                            '<div class="row region-importance">' +
                                '<div class="field-label">Importance</div>' +
                                '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                            '</div>' +
                            '<div class="row-50">' +
                                '<div>' +
                                    '<div class="field-label">Start Date</div>' +
                                    '<input type="date" name="start_date" class="solid compact">' +
                                '</div>' +
                                '<div>' +
                                    '<div class="field-label">Due Date</div>' +
                                    '<input type="date" name="due_date" class="solid compact">' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                        '<div class="modal-integration-innerscroll-footer">' +
                            '<button type="submit" class="primary" disabled>Send</button>' +
                        '</div>' +
                    '</form>';

        this.$el.html(content);

        if (this.form_value.title) {
            Form.setData(this.$el.find('form'), {
                title: this.form_value.title
            });
        }

        this.loadSendOptions();

        return this;
    }
});

export default Wrike_Send;